export function removeAssignment<T>(assignments: Record<string, T>, id: string) {
  const next = { ...assignments };
  delete next[id];
  return next;
}

export function toggleSelection(selectedIds: string[], id: string) {
  return selectedIds.includes(id) ? selectedIds.filter((selectedId) => selectedId !== id) : [...selectedIds, id];
}

export function therapistIdsForLearner(
  assignments: Array<{ learnerId: string; therapistId: string }>,
  learnerId: string,
) {
  return assignments.filter((entry) => entry.learnerId === learnerId).map((entry) => entry.therapistId);
}

export function isLearnerAssignedToTherapist(
  accounts: Array<{ id: string; therapistAssignments: Array<{ learnerId: string; organizationId: string | null }> }>,
  therapistId: string,
  learnerId: string,
  organizationId?: string,
) {
  return accounts.some((entry) => entry.id === therapistId && entry.therapistAssignments.some((assignment) => (
    assignment.learnerId === learnerId && (!organizationId || assignment.organizationId === organizationId)
  )));
}
